<template>
  <div class="CompanySelect">
    <van-field
      readonly
      clickable
      :label="label"
      :value="this.selectValue"
      :placeholder="placeholder"
      right-icon="arrow"
      @click="showTermPicker[model] = true"
    />
    <van-popup
      v-model="showTermPicker[model]"
      position="bottom"
      :style="{ height: '65%' }"
    >
      <div class="popupBox">
        <div class="handleHeader">
          <div class="cardBindManagement">选择企业</div>
          <div @click="showTermPicker[model] = false">
            <van-icon name="cross" />
          </div>
        </div>
        <div
          class="handleContentNoData"
          v-if="corpNameList.length === 0"
        >
          <div class="handleContentInfoNoData">暂无企业信息</div>
        </div>
        <div
          class="handleContent"
          v-else
        >
          <div
            class="handleContentList"
            @click="
              () => {
                handeIndex(index, e);
              }
            "
            :class="{ select: index === Index }"
            v-for="(e, index) in corpNameList"
            :key="index"
          >
            <div class="corpInfo">
              <div class="corpName">
                {{ e.corpName }}
              </div>
              <div>
                <span class="type">{{
                  e.userTypeDesc
                }}</span>
                <span
                  class="tip"
                  v-if="e.tag === 1"
                >该产品暂不支持股东申请 </span>
                <span
                  class="tip"
                  v-if="e.tag === 2"
                >该产品暂不支持法人申请
                </span>
                <span
                  class="tip"
                  v-if="e.tag === 3"
                >该产品未在贵公司登记注册地开放
                </span>
              </div>
            </div>
            <van-icon
              v-show="index === Index"
              :class="{ active: index === Index }"
              name="success"
            />
          </div>
        </div>
        <div
          @click="cardBindManagement"
          class="addCorp"
        >新增绑定企业</div>
      </div>
    </van-popup>
    <div class="term">
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanySelect',
  props: ['label', 'placeholder', 'getSelect', 'value'],
  data() {
    return {
      showTermPicker: {
        test: false,
      },
      model: 'test',
      Index: null,
      selectValue: '',
      corpNameList: [],
    };
  },
  mounted() {
    this.$api.PublicPage.getBindingEnterprise({
      productId: this.$route.query.productId,
    }).then((res) => {
      this.corpNameList = [...res.data];
      this.Index = this.corpNameList.findIndex((e) => e.corpName === this.selectValue);
    });
  },
  watch: {
    value: {
      handler(val) {
        this.selectValue = val;
      },
      deep: true,
      immediate: true,
    },

  },
  inject: ['root'],

  methods: {
    handeIndex(i, value) {
      // if (value.tag !== 0) return;
      this.Index = i;
      this.root.getSelect(value);
      this.selectValue = value.corpName;
      this.showTermPicker.test = false;
    },
    cardBindManagement() {
      localStorage.setItem(
        'returnPage',
        `/supermarket/v2/Perfect?productId=${this.$route.query.productId}`,
      );
      this.$router.push(
        '/supermarket/v2/bindingEnterprise',
      );
    },
  },
};
</script>
<style>
.CompanySelect {
  position: relative;
}
.van-field__label {
  text-align: left;
}
.popupBox {
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.handleHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
}
.handleContent {
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
.handleContentInfo {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  margin-top: 40%;
}
.handleContentNoData {
  flex: 1;
  overflow: auto;
  background: #fff;
  background: url("../../../../../assets/images/nodata.png") no-repeat top
    center;
  background-size: contain;
}
.handleContentInfoNoData {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  color: #b8c4cc;
  margin-top: 40%;
}
.active {
  color: #ff6538;
}
.handleContentList {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 16px;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.select {
  background: rgba(243, 242, 242, 0.644);
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
}
.cardBindManagement {
  font-family: PingFangSC-Medium;
  font-size: 17px;
  color: #1c2438;
}
.corpInfo {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
}
.corpName {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  color: #001f33;
}
.type {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #495060;
  margin-right: 4px;
}
.tip {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #a9b1bc;
}
.addCorp {
  height: 44px;
  margin: 16px 16px;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  background: #ff6538;
}
.translate {
  color: #a9b1bc;
}
.CompanySelect::after {
  position: absolute;
  right: 16px;
  bottom: 0;
  left: 16px;
  box-sizing: border-box;
  border-bottom: 1px solid #dddee1;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  content: " ";
  pointer-events: none;
}
.CompanySelect >>> .van-field__label {
  width: 80px;
}
</style>
